import axios from 'axios';
import Cookies from 'js-cookie';
import { deletePurchasesAction } from './DeletePurchasesSlice';

const deletePurchases = (productId) => {
  return async (dispatch) => {
    const body = {
      productId,
    };
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/purchases/delete`;
      const auth = `Bearer ${Cookies.get('auth_token')}`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: auth,
      };
      const response = await axios.post(url, body, {
        withCredentials: true,
        headers,
      });
      return response;
    };
    try {
      const deletePurchases = await fetchData();
      return dispatch(
        deletePurchasesAction.deletePurchasesHandler({
          data: deletePurchases.data,
          status: deletePurchases.status,
        })
      );
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove('auth_token');
        Cookies.remove('refresh_token');
        window.location.pathname = '/';
        window.history.pushState(null, document.title, window.location.href);
      }
      return e;
    }
  };
};

export default deletePurchases;
